// extracted by mini-css-extract-plugin
export var component = "Calendar-module--component--AbbTL";
export var content = "Calendar-module--content--NTOMy";
export var dates = "Calendar-module--dates--PHSet";
export var days = "Calendar-module--days--lfJ3V";
export var daysItem = "Calendar-module--daysItem--dqQwb";
export var empty = "Calendar-module--empty--M45sm";
export var title = "Calendar-module--title--a0LSV";
export var week = "Calendar-module--week--AWZyk";
export var weekTitle = "Calendar-module--weekTitle--66t8e";
export var weeks = "Calendar-module--weeks--N-uH9";